<lib-form-field-container [kind]="FormContainerKind.Checkbox">
    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value ? 'Selected' : 'Not selected' }}</div>
    </ng-container>

    <div
        class="d-flex"
        #splitMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="disabled ? null : splitMenu"
        [hidden]="isLoading">
        <lib-checkbox
            [qaTag]="qaTag ? qaTag + '-checkbox' : ''"
            [formControl]="formControl"
            [disabled]="disabled"
            [isIndeterminate]="isIndeterminate"
            (change)="Change($event)"></lib-checkbox>
        <lib-icon-button
            [qaTag]="qaTag ? qaTag + '-icon-button' : ''"
            [icon]="Icon.Common.CaretDown"
            [disabled]="disabled"
            [kind]="ButtonKind.NeutralTertiary"
            [size]="ButtonSize.Large"
            (clicked)="OpenMenuFromButton(splitMenuTrigger)"></lib-icon-button>
    </div>
</lib-form-field-container>

<mat-menu
    #splitMenu="matMenu"
    [hasBackdrop]="hasBackdrop">
    @for (item of menuItemComponents; track item) {
        <div
            class="v3"
            [attr.data-sb-qa]="item.qaTag">
            @if (item.menuDivider === MenuDivider.Above) {
                <mat-divider class="pb-2 mt-2 mx-2"></mat-divider>
            }
            <div class="ps-3 menu-item-header typography-body-medium-strong">
                <ng-container *ngTemplateOutlet="item.menuItemHeader"></ng-container>
            </div>

            @if (!item.hasSubOptions && !item.urlLink) {
                <button
                    [matTooltip]="item.toolTipText"
                    matTooltipPosition="after"
                    [ngClass]="{ 'disable-menu-item': item.disabled, 'menu-item-default': !item.hint, 'menu-item-with-hint': item.hint }"
                    mat-menu-item
                    (click)="MenuItemClicked(item, $event)">
                    <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                </button>
            } @else if (!item.hasSubOptions && item.urlLink) {
                <a
                    class="link-menu-item"
                    [matTooltip]="item.toolTipText"
                    matTooltipPosition="after"
                    [ngClass]="{ 'disable-menu-item': item.disabled, 'menu-item-default': !item.hint, 'menu-item-with-hint': item.hint }"
                    mat-menu-item
                    [href]="item.urlLink"
                    routerLinkActive="active"
                    target="_blank"
                    (click)="MenuItemClicked(item, $event)"
                    onclick="return false;">
                    <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                </a>
            }
            @if (item.menuDivider === MenuDivider.Below) {
                <mat-divider class="pt-2 mt-2 mx-2"></mat-divider>
            }
        </div>
    }
</mat-menu>

<ng-template
    #menuItem
    let-item>
    @if (item.label) {
        <div
            class="d-flex align-items-center h-100 my-auto"
            [ngClass]="{ 'menu-item-under-group': item.hasGroupHeader }">
            @if (item.prefixIcon) {
                <lib-icon
                    [icon]="item.prefixIcon"
                    [size]="IconSize.ExtraSmall"
                    [visible]="item.prefixIconVisible"
                    class="pe-2"></lib-icon>
            }
            <div>
                <p class="typography-input">{{ item.label }}</p>
                @if (item.hint) {
                    <small>{{ item.hint }}</small>
                }
            </div>
            @if (item.suffixIcon) {
                <lib-icon
                    [icon]="item.suffixIcon"
                    [size]="IconSize.ExtraSmall"
                    [visible]="item.suffixIconVisible"
                    class="ps-2"></lib-icon>
            }
        </div>
    } @else {
        <div
            class="d-flex align-items-center h-100 my-auto"
            [ngClass]="{ 'menu-item-under-group': item.hasGroupHeader }">
            <ng-container *ngTemplateOutlet="item.menuItemContent"></ng-container>
        </div>
    }
</ng-template>